import React, { lazy, Suspense } from 'react';

const retryCount = 1;

const pause = (timeout) => new Promise((resolve) => setTimeout(resolve, timeout));

export const retryAsyncFunction = async (
	fn,
	remainingRetries = retryCount + 1,
	interval = 750
) => {
	while (remainingRetries) {
		try {
			return await fn();
		} catch (e) {
			await pause(interval);
			remainingRetries -= 1;
			if (!remainingRetries) {
				throw e;
			}
		}
	}
};

export const lazyLoad = (importFunc) => {
	const LazyLoadedComponent = lazy(() => retryAsyncFunction(importFunc));

	// eslint-disable-next-line react/display-name
	return (props) => (
		<Suspense fallback={<div></div>}>
			<LazyLoadedComponent {...props} />
		</Suspense>
	);
};

export const lazyPreload = (factory) => {
	const Component = lazy(factory);
	Component.preload = factory;
	return Component;
};

export default lazyLoad;
